import {
	ConfigService
} from '../../'
import {
	MenuLink
} from '../'

export class MenuConfig {
	public color			= '#F00';
	public filter			= false;
	public iab:				MenuLink;
	public legend			= false;
	public more				= false;
	public selected		= '#F00';
	public unselected	= '#888';

	constructor(private configService: ConfigService) {}

	update(config: any): MenuConfig {
		if (typeof config.menu === 'object') {
			let t = typeof config.menu.iab === 'object' ? config.menu.iab : {};
			if (t !== {}) {
				this.iab = new MenuLink(t, null, null, this.configService);
			}

			this.color			= this.configService.getColor(config.menu.color, this.color);
			this.selected		= this.configService.getColor(config.menu.selected, this.selected);
			this.unselected	= this.configService.getColor(config.menu.unselected, this.unselected);
		}

		this.filter	= typeof config.filter  === 'object';
		this.legend	= typeof config.legend  === 'object';
		this.more		= typeof config.about   === 'object' ||
                  typeof config.login   === 'object' ||
                  typeof config.more    === 'object' ||
                  typeof config.support === 'object' ||
                  typeof config.terms   === 'object';

		return this;
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/config/menuConfig.ts